import React from 'react';
import {
    Container, Box, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Button
} from '@mui/material';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';

const UpdateResponseComp = ({ data }) => {
    const flattenedData = data.flatMap(batch => {
        return Object.keys(batch.message).map(email => ({
            batchId: batch.batchId,
            email: email,
            message: batch.message[email],
        }));
    });
    const exportToCsv = () => {
        const csv = Papa.unparse(flattenedData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'bulk_edit_upload_result.csv');
    };

    return (
        <Container style={{
            display: 'flex', flexDirection: 'column', width: '85vh',
            justifyContent: 'center', alignItems: 'center', padding: '2rem',
            overflow: 'hidden'
        }}>
            <Box sx={{
                width: '70vh', maxHeight: '50svh', overflow: 'auto',
                padding: 2, border: '1px solid #ccc', borderRadius: '10px',
            }}>
                <Button variant='contained' color='primary' onClick={exportToCsv} sx={{ marginBottom: 2, justifyContent: 'center' }}>
                    Download CSV
                </Button>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Batch ID</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Edit Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {flattenedData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.batchId}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.message}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Container>
    );
};

export default UpdateResponseComp;